import * as React from "react";
// import { pure } from 'recompose'
import * as moment from "moment";
import * as cx from "classnames";
import * as i18next from "i18next";
import * as Utils from "@Cyclope-Utils/index";
// import * as moment from 'moment-timezone';
import * as Lodash from "lodash";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { item, onRemoveInhibition, authorization, widthCart } = props;

  /**
   * @description : Choisir l'environnement de travail
   * @const
   * @type { string }
   * @name API_URL
   */
  // const API_URL : string = 'env';

  /**
   * @description : Récuperer les heures et dates
   * @const
   * @type { moment.Moment }
   * @name StarttimesMoment
   * @name EndtimesMoment
   */
  const StarttimesMoment: moment.Moment = moment(item.starttime);
  const EndtimesMoment: moment.Moment = moment(item.endtime);

  /**
   * @description : Comparer les dates et heures ( maintenant , hors delais et à venir )
   * @const
   * @type { boolean }
   * @name rightNow
   * @name outOfTime
   * @name nextTime
   */
  const rightNow: boolean =
    StarttimesMoment <= moment() && EndtimesMoment >= moment();
  const outOfTime: boolean =
    EndtimesMoment < moment() && StarttimesMoment < moment();
  const nextTime: boolean =
    StarttimesMoment > moment() && EndtimesMoment > moment();

  // /**
  //  * Triage dans un tableau par ordre
  //  * @method onSortDynamic
  //  * @param { any[] }  Elem
  //  * @return { any []}
  //  * @infos "https://reactjs.org"
  //  */
  // const onSortDynamic = (Elem: any) : any=> {
  //     { /** vérification de l'existence de l'élement  */}
  //     if( Lodash.isArray(Elem)){
  //         return  Elem.sort((a: any,b: any) => (a.code > b.code) ? 1 : ((b.code > a.code) ? -1 : 0))
  //     }

  // }
  /**
   * @description : le tableua relatif
   * à la position de l'incidents
   * @const
   * @name dataCar
   * @type { strin[]  }
   */
  const dataCar: string[] = [
    i18next.t("voie de gauche"),
    i18next.t("voie de droite"),
    i18next.t("parking"),
    i18next.t("bau"),
    i18next.t("trottoir"),
  ];

  /**
   * Triage dans un tableau par ordre
   * @method onSortDynamicLocation
   * @param { any[] }  Elem
   * @return { any []}
   * @infos "https://reactjs.org"
   */
  const onSortDynamicLocation = (Elem: any): any => {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (Lodash.isArray(Elem)) {
      return Elem.sort((a: any, b: any) =>
        a.location > b.location ? 1 : b.location > a.location ? -1 : 0
      );
    }
  };
  // const widthCart= Math.ceil(Utils.fullWidthContent() * 0.324) + "px";
  /**
   * @description : Liste des caméras
   * @const
   * @type { any[] }
   * @name cameraList
   */
  const cameraList: any[] = item.cameras && onSortDynamicLocation(item.cameras);

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML 380px
   * @external
   * @name i18next
   * @name moment
   * @infos "https://reactjs.org"
   */
  return (
    <div
      className="Vcart-vcart animated fadeIn "
      style={{
        height: "100%",
        width: `${widthCart}px`,
        marginRight: "15px",
        marginBottom: "0",
      }}
    >
      <div className="cartIncidents">
        <div
          className={cx("headerInhibitions", {
            rightNow,
            outOfTime,
            nextTime,
          })}
        >
          <span>
            {i18next.t("inhibition")} | {item.origin} | # {item.id}
            {(rightNow || nextTime) && (
              <p className="inhibitionTimes">
                {Utils.localDateFrFormat(StarttimesMoment)} --{" "}
                {Utils.localDateFrFormat(EndtimesMoment)}
              </p>
            )}
            {outOfTime && (
              <p className="inhibitionTimes">
                {" "}
                {Utils.localDateFrFormat(EndtimesMoment)}
              </p>
            )}
          </span>
          {rightNow && <span> {i18next.t("en cours")}</span>}
          {outOfTime && <span>{i18next.t("terminees")}</span>}
          {nextTime && <span>{i18next.t("a venir")}</span>}
          {item.starttime === null && <span> {i18next.t("en cours")}</span>}
        </div>
        <div className="cartIncidentContent">
          <p> {i18next.t("incidents inhibes")}</p>
          <div className="cartIncidentContentInhibition">
            {item.incidentTypes &&
              item.incidentTypes.map((Elem: any, index: number) => {
                return (
                  <div
                    className="part-right left"
                    style={{ height: "unset", marginBottom: "2px" }}
                    key={index}
                  >
                    <span> {i18next.t(`${Elem.label}`)}</span>{" "}
                  </div>
                );
              })}
          </div>
        </div>
        <div className="cartSectionContent">
          <p> {i18next.t("perimetres")}</p>
          {item.sections && item.sections[0] && (
            <span>
              {i18next.t("section")} : {item.sections[0].name}
            </span>
          )}
          {cameraList && cameraList[0] && (
            <span>
              {i18next.t("camera")} : {i18next.t("de")} {cameraList[0].code}{" "}
              {i18next.t("à")}{" "}
              {cameraList[item.cameras.length - 1] &&
                cameraList[item.cameras.length - 1].code}
            </span>
          )}
          {item.laneId && (
            <span>
              {i18next.t("la voie")} : {dataCar[Number(item.laneId)]}
            </span>
          )}
        </div>
        <div className="cartBottomContent">
          {authorization && (
            <button
              className="btnPrimary ripple"
              style={{ padding: "8px 20px" }}
              onClick={onRemoveInhibition}
            >
              {i18next.t("supprimer")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

Component.defaultProps = {
  IncidentsType: [],
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  item?: any;
  onRemoveInhibition?: any;
  authorization?: any;
  widthCart?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/box/inhibitions/component.tsx